import { formatCellValue, TruncatedText } from "@/components/contracts/table-utils";
import { DataTable } from "@/components/shared/data-table";
import type { PrivateHireSetdown } from "@/lib/coach-manager/types";

export function PrivateHireSetdownsTable({ setdowns }: { setdowns: PrivateHireSetdown[] }) {
  if (setdowns.length === 0) return null;

  return (
    <DataTable
      headers={[
        { label: "Setdown Point" },
        { label: "Arrival Day" },
        { label: "Arrival Time" },
        { label: "Setdown Day" },
        { label: "Setdown Time" },
        { label: "Latitude" },
        { label: "Longitude" },
        { label: "Instructions" },
      ]}
    >
      {setdowns.map((setdown) => (
        <tr key={setdown.PrivateHireSetdownID} className="border-b last:border-b-0">
          <td className="px-4 py-2">{formatCellValue(setdown.SetdownPoint)}</td>
          <td className="px-4 py-2">{setdown.ArrivalDayNo}</td>
          <td className="px-4 py-2">{formatCellValue(setdown.ArrivalTime)}</td>
          <td className="px-4 py-2">{setdown.SetdownDayNo}</td>
          <td className="px-4 py-2">{formatCellValue(setdown.SetdownTime)}</td>
          <td className="px-4 py-2">{formatCellValue(setdown.Latitude)}</td>
          <td className="px-4 py-2">{formatCellValue(setdown.Longitude)}</td>
          <td className="px-4 py-2">
            <TruncatedText value={setdown.Instructions} />
          </td>
        </tr>
      ))}
    </DataTable>
  );
}
